<mat-form-field class="w-100 " [ngClass]="{'required': _required}">
  <mat-label>{{_label}}</mat-label>
  <input
    [type]="_type"
    matInput
    [value]="_selectedDate"
    [disabled]="_isDisabled"
    (change)="selectedDateChanged($event)"
    [max]="_maxDate"
    [min]="_minDate"
    [required]="_required">
</mat-form-field>